<!-- ECU設定情報の書込み ダイアログ -->
<b-modal v-model="modal_requirement_170" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid requirement170-body">
        <template v-if="isInputPhase">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="w-100 mb-4">
                <div class="text-center work-support-message requirement170-input-title">
                  {{ $t(`individual.label_input_applied_op`) }}
                </div>
                <table class="box-margin-right box-margin-top work-support-message requirement170-input-table">
                  <tbody>
                    <tr>
                      <td class="requirement170-input-label">{{ $t(`individual.label_table_applied_model`) }}</td>
                      <td>
                        <b-form-group>
                          <b-form-input v-model="inputAppliedModel"
                            :state="validateAppliedModel && !validateAppliedModel.valid" type="text" size="sm"
                            autocomplete="off">
                          </b-form-input>
                          <b-form-invalid-feedback v-if="validateAppliedModel">
                            {{ validateAppliedModel.msg }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </td>
                    </tr>
                    <tr>
                      <td class="requirement170-input-label">{{ $t(`individual.label_table_option_code`) }}</td>
                      <td>
                        <b-form-group>
                          <b-form-input v-model="inputOptionCode"
                            :state="validateOptionCode && !validateOptionCode.valid" type="text" size="sm"
                            autocomplete="off">
                          </b-form-input>
                          <b-form-invalid-feedback v-if="validateOptionCode">
                            {{ validateOptionCode.msg }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="w-100">
            <div class="box-margin-right work-support-message requirement170-message">
              {{ workSupportMessage }}
            </div>
          </div>
        </template>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center">
      <b-button v-if="showButtonCancel" size="sm" :disabled="isLoading" variant="outline-primary"
        @click="onCancelClicked" class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" :disabled="isOkDisabled" variant="primary"
        @click="onOkClicked" class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>
